














import { Component, Vue } from "vue-property-decorator"
@Component({})
export default class saveTemplate extends Vue {
    tpName: string = "";
    saveNumber: boolean = false;

    cancel() {
        this.$emit("cancel")
    }
    confirmSave() {
        this.$emit("confirm", this.tpName, this.saveNumber, null, 0)
    }
}
